import React, {useState} from 'react'
import Header from '../Layout/Header'
import SideBar from '../Layout/SideBar'

const EditUser = () => {
    const [profileImage, setProfileImage] = useState(null);

    const handleImageChange = (event) => {
      const file = event.target.files[0]; 
      if (file) {
        const preview = URL.createObjectURL(file);
        setProfileImage(preview);
      }
    };
  return (
    <>
      <Header />
      <SideBar />
      <main>
        <div className="content-wrapper pt-5 create_user">
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-header">
                      <h2>Edit User</h2>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-3">
                          <div className="addImg_sec">
                            <div className="adduser_img" >
                              {profileImage ? (
                                <img  src={profileImage}   alt="Profile Preview" />
                              ) : (
                                <div className="pro-img">
                                 <img src="assets/img/profile.jpeg" alt="" />
                                </div>
                              )} 
                            </div>
                            <input type="file" accept="image/*"  onChange={handleImageChange} />
                          </div>
                        </div>
                        <div className="col-md-9">
                          <form action="">
                            <div className="row">
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="fname">First Name</label>
                                  <input type="text" className="form-control" id="fname" />
                                </div>
                              </div>
                              <div className="col-md-6">
                               <div className="form-group">
                                  <label htmlFor="lname">Last Name</label>
                                  <input type="text" className="form-control" id="lname" />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="email">Email</label>
                                  <input type="text" className="form-control" id="email" />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="form-group">
                                  <label htmlFor="number">Phone Number</label>
                                  <input type="text" className="form-control" id="number" />
                                </div>
                              </div>
                              <div className="col-md-6">
                                <button className="btn btn-primary"> Submit </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </>
  )
}

export default EditUser
